<template>
    <a-modal
      :visible="show"
      @cancel="$emit('close')">
      <h3 slot="title">
        <a-icon class="mr-2" type="cloud-download" />
        {{$t('msg.account.export.title')}}
      </h3>
      <!-- Form -->
      <div class="mb-2">
        {{ $t('msg.account.export.subtitle1') }}
        <a-tooltip
          placement="right"
          :title="$t('msg.account.export.warning', { limit })"
          v-if="blocked">
          <a-icon
            type="exclamation-circle"
            class="text-danger font-size-14 ml-1" />
        </a-tooltip>
      </div>
      <!-- Email -->
      <div class="mt-3 mb-2">
        {{ $t('msg.account.export.subtitle2') }}
      </div>
      <a-input
        v-model="email"
        size="large"
        read-only />
      <!-- Actions -->
      <div slot="footer" class="p-3">
        <a-button
          key="back"
          @click="onCancel">
          {{$t('cancel')}}
        </a-button>
        <a-button
          key="submit"
          type="primary"
          :loading="loading"
          :disabled="blocked"
          @click="onConfirm">
          {{$t('export')}}
        </a-button>
      </div>
    </a-modal>
  </template>
<script>
import lms from '@/api/lms'
import { flatJsonFields } from '@/utils/requests'
export default {
  props: ['show'],
  data() {
    return {
      limit: 10000,
      loading: false,
    }
  },
  computed: {
    visible() {
      return this.show
    },
    email() {
      return this.$store.getters['session/USER'].email
    },
    filters() {
      return this.$store.getters['account/FILTERS']
    },
    blocked() {
      return false
    },
  },
  methods: {
    onConfirm() {
      this.loading = true
      const filters = flatJsonFields(this.filters)
      const request = {
        type: 'ACCOUNT_RATES',
        email: this.email,
        filter: filters,
      }
      lms.account.exportRates(request)
        .then(_ => this.$router.push('/accounts/exported'))
        .finally(() => (this.loading = false))
    },
    onCancel() {
      this.$emit('close')
    },
  },
}
</script>
